import { useWatchBaseNotification } from "./useWatchBaseNotification";
import { ENotificationType, INotification } from "../interfaces";
import { InternalCallNotificationMeta } from "@components/internal-contacts/_types/internalCall.types";

const INTERNAL_CALL_TYPES = [
  ENotificationType.InternalCallIncoming,
  ENotificationType.InternalCallAccepted,
  ENotificationType.InternalCallRejected,
  ENotificationType.InternalCallMissed,
  ENotificationType.InternalCallCanceled,
  ENotificationType.InternalCallEnded,
  ENotificationType.InternalCallReady,
  ENotificationType.InternalCallTaken,
];

export interface UseWatchInternalCallNotificationsProps {
  onNotificationArrived?: (
    notification: INotification<InternalCallNotificationMeta>,
  ) => void;
}

export const useWatchInternalCallNotifications = ({
  onNotificationArrived,
}: UseWatchInternalCallNotificationsProps = {}) =>
  useWatchBaseNotification<InternalCallNotificationMeta>({
    notificationTypes: INTERNAL_CALL_TYPES,
    dissableSnackbarAlert: true,
    onNotificationArrived,
  });
